<template>
  <span class="d-book-user-reviews-count label label-sm label-round">
    {{ userReviewsCount }}
  </span>
</template>

<script>
export default {
  props: {
    bookSlug: {
      type: String,
      required: true,
    },
  },
  computed: {
    userReviewsCount() {
      return this.$store.getters['BookUserReviews/get-count'];
    },
  },
  mounted() {
    this.loadCount();
  },
  methods: {
    loadCount() {
      this.$store.dispatch('BookUserReviews/loadCount', this.bookSlug);
    },
  },
};
</script>
